import React from 'react';
interface FooterProps {
  'data-id'?: string;
}
export const Footer: React.FC<FooterProps> = ({
  'data-id': dataId
}) => {
  return <footer className="relative w-full bg-[#121212] overflow-hidden" data-id="element-1691">
      <div className="flex flex-col items-center justify-center py-12 md:py-16 gap-6" data-id="element-1692">
        <a href="/" aria-label="AcquireFlow Home" data-id="element-1693">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dxuXv5AoswiCCU7F4ucVPA/AcquireFlow_Logo_%287%29.svg" alt="AcquireFlow" className="h-10 md:h-12" data-id="element-1694" />
        </a>
        <p className="text-sm md:text-base font-medium text-[#b8bcc8] text-center flex items-center gap-2" data-id="element-1695">
          ©2026 AcquireFlow. Built for investors, by investors.
        </p>
      </div>
    </footer>;
};